import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
		VyrobekndOzn: [],
	},
	edit: {
		AktzaznPoc: null as number | null,
		PreceneniId: null as number | null,
		SkladOzn: null as number | null,
		Text: null as string | null,
		VerzeDat: null as Date | null,
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		VyrobekndOzn: null as string | null,
		SkladOznText: null as string | null,
	},
	localState: {},
	depTableNames: [],
	depTableSettings: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
